import React from "react";
import {
  FaEnvira,
  FaClipboardCheck,
  FaClipboardList,
  FaHome,
  FaFileInvoice,
  FaToolbox,
  FaPhoneSquare,
  FaExclamationCircle
} from "react-icons/fa";

const locationData = [
  {
    title: "Accueil",
    location: "",
    headerImageName: "homeImage"
  },
  {
    logo: <FaEnvira />,
    title: "Engagements",
    location: "engagements-et-missions",
    id: "engagements",
    headerImageName: "engagementImage"
  },
  {
    logo: <FaClipboardCheck />,
    title: "Missions",
    location: "engagements-et-missions",
    id: "missions",
    headerImageName: "engagementImage"
  },
  {
    logo: <FaClipboardList />,
    title: "Étapes d'un chantier",
    location: "engagements-et-missions",
    id: "etapes",
    headerImageName: "engagementImage"
  },
  {
    logo: <FaHome />,
    title: "Projets",
    location: "projets",
    headerImageName: "projectImage"
  },
  {
    logo: <FaFileInvoice />,
    title: "Actualités",
    location: "actualites",
    headerImageName: "newsImage"
  },
  {
    logo: <FaToolbox />,
    title: "Partenaires et outils",
    location: "partenaires-et-outils",
    headerImageName: "partnerImage"
  },
  {
    logo: <FaPhoneSquare />,
    title: "Contacts",
    location: "contacts",
    headerImageName: "contactImage"
  },
  {
    logo: <FaPhoneSquare />,
    title: "Merci",
    location: "merci",
    headerImageName: "contactImage"
  },
  {
    logo: <FaExclamationCircle />,
    title: "Page non trouvée",
    location: "404",
    headerImageName: "notFoundImage"
  }
];

const getTitleData = (location, id) => {
  let titleData;
  if (location.pathname === "/") titleData = locationData[0];
  else
    for (let i = 1; i < locationData.length; i++) {
      //in locationData, look for the right object depending on current location and id if present
      if (
        location.pathname
          .replace(/\//g, "")
          .search(locationData[i].location.replace(/\//g, "")) !== -1 &&
        (!id || id === locationData[i].id)
      ) {
        titleData = locationData[i];
        break;
      }
    }
  return titleData;
};

export default getTitleData;
